import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStore } from '@shared/store/auth.store';
import { catchError, throwError } from 'rxjs';

export const forbiddenErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const authStore = inject(AuthStore);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 403) {
        authStore.resetState();
        router.navigate(['/auth/sign-in']);
      }
      return throwError(() => err);
    })
  );
};
